import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { InputAdornment, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import UpdateIcon from "@mui/icons-material/Update";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import { ModalDocumentacionReestructuracion } from "./Modales/ModalDocumentacionReestructuracion";

export const CargarDocumentacionReestructuracion = ({ folio, setLoader, loader }) => {
    const [openComentarios, setOpenComentarios] = useState(false);
    const [comentarios, setComentarios] = useState("");
    const [doctoselect, setDoctoSelect] = useState({
        iddocumento: "",
        documento: "",
    });
    const [accion, setAccion] = useState("");
    const [data, setData] = useState({
        estado: {},
        documentacion: [],
    });
    const [documentoselect, setDocumentoSelect] = useState({});
    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };
    useEffect(() => {
        onObtenerAnalisisDocumentacion();
    }, []);
    const onObtenerAnalisisDocumentacion = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ACJDF_Analisis_Documentacion/Listado?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon className="wait" />;
            case "success":
                return <CheckCircleIcon className="success" />;
            case "warning":
                return <WarningIcon className="warning" />;
            case "error":
                return <ErrorIcon className="error" />;
            default:
                <></>;
        }
    };
    const onImprimirArchivo = (iddocumento) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
                    iddocumento
                )}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.comentarios;
                const downloadLink = document.createElement("a");
                const fileName = `${result.documento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onEnviarComentario = () => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso: 13,
            iddocumento: doctoselect.iddocumento,
            consecutivo: -1,
            comentarios,
            estatus: accion,
        };
        request
            .post("ACTimelineComentariosTask", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
                setComentarios("");
                setOpenComentarios(false);
                setDoctoSelect({
                    iddocumento: "",
                    documento: "",
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const onAceptar = (iddocumento, documento) => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso: 13,
            iddocumento: iddocumento,
            consecutivo: -1,
            comentarios: `DOCUMENTO VALIDADO`,
            estatus: "A",
        };
        request
            .post("ACTimelineComentariosTask", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData({
                    estado: result.estado,
                    documentacion: result.documentacion,
                });
                setComentarios("");
                setOpenComentarios(false);
                setDoctoSelect({
                    iddocumento: "",
                    documento: "",
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const openModal = (documento, iddocumento) => {
        var modal = document.getElementById("modal-documentos");
        modal.style.display = "block";
        setDocumentoSelect({
            documento,
            iddocumento,
        });
    };

    const onImprimirPagare = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`Pagares/ImprimirPagare?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                if (result.length > 0) {
                    result.forEach((documento, index) => {
                        const linkSource = `data:application/pdf;base64, ${documento.documento}`;
                        const downloadLink = document.createElement("a");
                        const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension}`; // Añade el número de documento al nombre del archivo
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                } else {
                    Swal.fire("Clientes", "No se encontraron documentos para descargar", "info");
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onDescargarPedido = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onDescargarPagare = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`Pagares/ImprimirPagare?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                if (result.length > 0) {
                    result.forEach((documento, index) => {
                        const linkSource = `data:application/pdf;base64, ${documento.documento}`;
                        const downloadLink = document.createElement("a");
                        const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
                            }`; // Añade el número de documento al nombre del archivo
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                } else {
                    Swal.fire(
                        "Clientes",
                        "No se encontraron documentos para descargar",
                        "info"
                    );
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };
    return (
        <div className="analisis-solicitud-credito-proceso">
            <ModalDocumentacionReestructuracion
                folio={folio}
                documento={documentoselect.documento}
                iddocumento={documentoselect.iddocumento}
                loader={loader}
                setLoader={setLoader}
                setdocumento={setDocumentoSelect}
                setdocumentos={onObtenerAnalisisDocumentacion}
                cargar={true}
            />
            <div
                className={"analisis-credito-modal-mhusa-content-pdf-original"}
                onClick={() => onDescargarPedido()}
            >
                <CloudDownloadIcon />
                <div>Descargar pedido original</div>
            </div>
            <div
                className={"analisis-credito-modal-mhusa-content-pdf-original"}
                onClick={() => onDescargarPagare()}
            >
                <CloudDownloadIcon />
                <div>Descargar pagare original</div>
            </div>
            <div className="analisis-solicitud-credito-proceso-container-JDF scroll-4">
                {data.documentacion === undefined ||
                    data.documentacion === null ||
                    data.documentacion.length === 0 ? (
                    <div></div>
                ) : (
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>

                                <th>DOCUMENTO</th>
                                {/* <th></th> */}
                                <th>Descargar</th>
                                <th>Cargar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.documentacion.map((doc) => (
                                <tr>
                                    <td>{doc.documento}</td>
                                    {/* <td></td> */}
                                    <td>
                                        {doc.tiene_documentacion === true ? (
                                            <div onClick={() => onImprimirArchivo(doc.iddocumento)}>
                                                <CloudDownloadIcon />
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </td>
                                    {doc.habilitar === false ? (
                                        <div></div>
                                    ) : (
                                        <td className="update-documento-analisis">
                                            <div
                                                onClick={() =>
                                                    openModal(doc.documento, doc.iddocumento)
                                                }
                                            >
                                                <CloudUploadIcon />
                                                Cargar
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <div className="analisis-solicitud-credito-proceso-footer scroll-4">
                {openComentarios && (
                    <TextField
                        fullWidth
                        size="small"
                        label={doctoselect.documento}
                        className="cel-1"
                        multiline
                        rows={3}
                        type="text"
                        // error={condiciones.bcondiciones}
                        onChange={({ target }) => {
                            ValSpecialCharacters(
                                "comentarios",
                                target.value,
                                onChange,
                                true,
                                500
                            );
                        }}
                        value={comentarios}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start">
                                    <CancelScheduleSendIcon
                                        fontSize="small"
                                        onClick={() => onEnviarComentario()}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                )}
            </div>
        </div>
    );
};
